// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

export const SENDANOR_HOSTING_BANK_ACCOUNT_ID = '1002';
export const SENDANOR_HOSTING_BANK_NAME = 'Osuuspankki';
export const SENDANOR_HOSTING_IBAN = 'FI11 5741 3620 4717 45';
export const SENDANOR_HOSTING_BIC = 'OKOYFIHH';

export const SENDANOR_BANK_ACCOUNT_ID = '1000';
export const SENDANOR_BANK_NAME = 'Osuuspankki';
export const SENDANOR_IBAN = 'FI05 5741 3620 3718 46';
export const SENDANOR_BIC = 'OKOYFIHH';
